import React, { useState, useEffect } from "react";
import { useMutation } from "graphql-hooks";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  Avatar,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import CloseIcon from "@mui/icons-material/Close";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import ModeCommentOutlinedIcon from "@mui/icons-material/ModeCommentOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";

import FloatingMenu from "./components/FloatingMenu";
import storyImg from "./assets/story-img.png";
import sampleAvatar from "./assets/SearchResults/Avatars/Sarah_White.png";


import { CREATE_STORY_MUTATION } from "./graphQL/story_qry";

export default function AddStory() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [photoName, setPhotoName] = useState("");
  const [photoSize, setPhotoSize] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [showFullStory, setShowFullStory] = useState(false);
  const [floatMenuLeftMargin, setFloatMenuLeftMargin] = useState(0);
  
  // Form validation errors
  const [errors, setErrors] = useState({
    title: "",
    content: ""    
    
  });

  const userUuid = localStorage.getItem("userUuid")

  console.log('userUuid',userUuid)

  const [createStory] = useMutation(CREATE_STORY_MUTATION, {
    awaitRefetchQueries: true,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Set floating menu place based on screen size
  useEffect(() => {
    const handleResize = () => {
      setFloatMenuLeftMargin(window.innerWidth - 100);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);
  }, []);

  const handlePhotoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPhoto(file);
      setPhotoName(file.name);
      // Calculate file size in KB
      const sizeInKB = (file.size / 1024).toFixed(0);
      setPhotoSize(`${sizeInKB} KB`);

      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemovePhoto = () => {
    setPhoto(null);
    setPhotoPreview(null);
    setPhotoName("");
    setPhotoSize("");
    // Reset file input
    const fileInput = document.getElementById("photo-upload");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  
  const addTimeStampToFilename = (fileName) => {
  const ext = fileName.substring(fileName.lastIndexOf("."));
  const name = fileName.substring(0, fileName.lastIndexOf("."));
  const timestamp = Date.now();
  return `${name}_${timestamp}${ext}`;
 };


  const handleSave = async (publish) => {
    
    const newErrors = {};
    
    
    if (!title.trim()) {
          newErrors.title = "Title cannot be blank.";
          
      }

    if (!content.trim()) {
          newErrors.content =  "Content cannot be blank.";
          
      }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;
    
    

      // -------------------------------
      // Generate S3 filename & send file
      // -------------------------------
      let s3FileName = null;
      let fileToUpload = null;

      if (photo) {
        s3FileName = addTimeStampToFilename(photo.name);  
        fileToUpload = photo;                             
      }

      
      const { data, error } =  await createStory({
          variables: {
            title: title,
            content: content,
            isPublished: publish,
            userUuid: userUuid,
            file: fileToUpload,      // <-- send file to backend
            s3FileName: s3FileName,  // <-- send timestamped filename
          },
        });

        
        if (error) {
          console.log("Error", error, data);
          
          // setTimeout("");
        } else {
          console.log("Success",data);
          navigate("/my-stories/");
          
        }
    
  };

  const handleTitleChange = e => {
    setTitle(e.target.value);
    if (e.target.value.toString().trim() === "") {
      setErrors({ ...errors, title: "Title cannot be blank." });
    } else {
      setErrors({ ...errors, title: "" });
    }
  };

const handleContentChange = e => {
    setContent(e.target.value);
    if (e.target.value.toString().trim() === "") {
      setErrors({ ...errors, content: "Content cannot be blank." });      
    } else {
      setErrors({ ...errors, content: "" });
    }
  };



  const handleCancel = () => {
    // Reset form
    setTitle("");
    setContent("");
    setPhoto(null);
    setPhotoPreview(null);
    setPhotoName("");
    setPhotoSize("");
    // Reset file input
    const fileInput = document.getElementById("photo-upload");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const handlePreview = () => {
    setPreviewOpen(true);
    setShowFullStory(false);
  };

  const handleClosePreview = () => {
    setPreviewOpen(false);
    setShowFullStory(false);
  };

  // Get username from localStorage
  const userName = localStorage.getItem("userName") || "";


  return (
    
      <Box
        sx={{
          backgroundColor: "#f5f5f5",
          minHeight: "100vh",
          py: 5,
          px: "100px",
          "@media (max-width: 1360px)": {
            px: "16px",
          },
        }}
      >
        <Helmet>
          <title>R3PLAY - Add Story</title>
          <meta
            name="description"
            content="Share your toy story with the community"
          />
        </Helmet>

        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mb: 5,
            "@media (max-width: 856px)": {
              mb: 3,
            },
          }}
        >
          <Box
            sx={{
              width: 48,
              height: 48,
              minWidth: 48,
              minHeight: 48,
              backgroundColor: "white",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <AutoStoriesOutlinedIcon
              sx={{
                color: "#01579B",
                fontSize: "24px",
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h4"
              sx={{
                fontSize: "30px",
                fontWeight: "700",
                color: "#333",
                mb: 0.5,
                "@media (max-width: 856px)": {
                  fontSize: "24px",
                },
              }}
            >
              Add Story
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "#666",
                "@media (max-width: 856px)": {
                  fontSize: "13px",
                },
              }}
            >
              Every toy has a story! Add a catchy title and share your
              experience with others in the toy community.
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "12px",
            p: 3,
            "@media (max-width: 856px)": {
              p: 2,
            },
            mt: 2,
          }}
        >
          {/* Form */}
          <Box>
            {/* Title/Summary Field */}
            <TextField
              fullWidth
              label="Title/Summary"
              placeholder="Enter a catchy title for your story"
              variant="outlined"
              required
              value={title}
              onChange={handleTitleChange}
              error={!!errors.title}
              helperText={errors.title}
              sx={{
                mb: 3,
                "& .MuiInputBase-root": { height: "56px" },
              }}
            />

            {/* Content Field */}
            <TextField
              fullWidth
              label="Content"
              placeholder="Share your story..."
              variant="outlined"
              required
              multiline
              rows={4}
              value={content}
              onChange={handleContentChange}
              error={!!errors.content}
              helperText={errors.content}
              sx={{
                mb: 3,
              }}
            />

            {/* Upload Story Photo Field */}
            <Box sx={{ mb: 3, position: "relative" }}>
              <TextField
                fullWidth
                label="Upload Story Photo"
                placeholder="No file selected"
                variant="outlined"
                value={photoName}
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  "& .MuiInputBase-root": { height: "56px" },
                }}
              />
              <input
                accept="image/*"
                style={{ display: "none" }}
                id="photo-upload"
                type="file"
                onChange={handlePhotoUpload}
                disabled={!!photo}
              />
              <label htmlFor="photo-upload">
                <Button
                  component="span"
                  variant="outlined"
                  startIcon={<UploadFileIcon />}
                  disabled={!!photo}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    borderColor: "#666",
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                    color: "#666",
                    textTransform: "none",
                    px: 2,
                    "@media (max-width: 856px)": {
                      px: 1,
                    },
                    height: "36px",
                    "&:hover": {
                      borderColor: "#666",
                      backgroundColor: "rgba(0, 0, 0, 0.08)",
                    },
                    "&.Mui-disabled": {
                      borderColor: "#e0e0e0",
                      color: "#9e9e9e",
                    },
                  }}
                >
                  Upload Image
                </Button>
              </label>
            </Box>

            {/* Photo Preview */}
            {photoPreview && (
              <Box
                sx={{ mb: 3, position: "relative", display: "inline-block" }}
              >
                <IconButton
                  size="small"
                  onClick={handleRemovePhoto}
                  sx={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                    backgroundColor: "white",
                    boxShadow: 1,
                    zIndex: 1,
                    width: "24px",
                    height: "24px",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
                <Box
                  component="img"
                  src={photoPreview}
                  alt="Story preview"
                  sx={{
                    width: "200px",
                    height: "200px",
                    objectFit: "cover",
                    borderRadius: "4px",
                    border: "1px solid #ddd",
                  }}
                />
                <Box sx={{ textAlign: "center", mt: 1 }}>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#666",
                    }}
                  >
                    File: {photoName}
                  </Typography>
                  <Typography
                    sx={{
                      mt: 0.5,
                      color: "#999",
                      fontSize: "12px",
                    }}
                  >
                    Size: {photoSize}
                  </Typography>
                </Box>
              </Box>
            )}

            {/* Action Buttons */}
            <Box
              sx={{
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  "@media (max-width: 856px)": {
                    gap: 1,
                  },
                  flexWrap: "wrap",
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => handleSave(true)}
                  disabled={!title || !content}
                  sx={{
                    height: "42px",
                    px: 3,
                    fontWeight: 500,
                    backgroundColor: "#EF5658",
                    "@media (max-width: 856px)": {
                      fontSize: "13px",
                      height: "30px",
                      px: 1,
                    },
                  }}
                >
                  Save & Post
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => handleSave(false)}
                  sx={{
                    backgroundColor: "#fff",
                    color: "#ef5658",
                    borderColor: "rgba(239, 86, 88, 0.5)",
                    borderRadius: "4px",
                    height: "42px",
                    px: 3,
                    fontWeight: 500,
                    "&:hover": {
                      borderColor: "#EF5658",
                      backgroundColor: "rgba(239, 86, 88, 0.1)",
                    },
                    "@media (max-width: 856px)": {
                      fontSize: "13px",
                      height: "30px",
                      px: 1,
                    },
                  }}
                >
                  Save as Draft
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  sx={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderColor: "#000",
                    height: "42px",
                    px: 3,
                    fontWeight: 500,
                    "&:hover": {
                      backgroundColor: "#fff",
                      color: "#000",
                      borderColor: "#000",
                    },
                    "@media (max-width: 856px)": {
                      height: "30px",
                      fontSize: "13px",
                      px: 1,
                    },
                  }}
                >
                  Cancel
                </Button>
              </Box>
              <Button
                variant="outlined"
                onClick={handlePreview}
                disabled={!title || !content}
                sx={{
                  backgroundColor: "#fff",
                  color: "#ef5658",
                  borderColor: "rgba(239, 86, 88, 0.5)",
                  borderRadius: "4px",
                  height: "42px",
                  px: 3,
                  fontWeight: 500,
                  "&:hover": {
                    borderColor: "#EF5658",
                    backgroundColor: "rgba(239, 86, 88, 0.1)",
                  },
                  "@media (max-width: 856px)": {
                    height: "30px",
                    fontSize: "13px",
                    px: 1,
                  },
                }}
              >
                Preview Story
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Preview Dialog */}
        <Dialog
          open={previewOpen}
          onClose={handleClosePreview}
          maxWidth={false}
          sx={{
            zIndex: 2100,
          }}
          PaperProps={{
            sx: {
              maxHeight: "650px",
              borderRadius: "12px",
              p: 1,
              width: "380px",
              maxWidth: "95vw",
              "@media (max-width: 1360px)": {
                px: 1,
              },
            },
          }}
        >
          <DialogContent sx={{ p: 0, overflowX: "visible" }}>
            {/* Dialog Header */}
            <Box sx={{ textAlign: "center", mb: 2 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "22px",
                  fontWeight: "700",
                  color: "#333",
                  mb: 1,
                  "@media (max-width: 856px)": {
                    fontSize: "24px",
                  },
                }}
              >
                Story Preview 
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleClosePreview}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Story Card Preview */}
            <Card
              sx={{
                width: 288,
                height: 541,
                margin: "0 auto",
                border: "1px solid #01579B",
                borderRadius: "12px",
                boxShadow: "none",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              {/* User Header */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  py: 1,
                  px: 1,
                  backgroundColor: "#E1F5FE",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Avatar src={sampleAvatar} sx={{ width: 40, height: 40 }} />
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography variant="body2" fontWeight="bold">
                      {userName}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Just now
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Story Image */}
              {photoPreview && (
                  <CardMedia component="img" image={photoPreview} alt={title} 
                              sx={{
                                    width: 288,
                                    height: 288,
                                    objectFit: "cover",
                                  }}/>
                )}              

              {/* Story Content */}
              <CardContent
                sx={{
                  pb: 1,
                  backgroundColor: "#E1F5FE",
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <Typography
                  variant="body2"
                  fontWeight="bold"
                  sx={{
                    color: "black",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minHeight: "2.8em",
                    lineHeight: "1.4em",
                  }}
                >
                  {title}
                </Typography>

                {!showFullStory &&
                content &&
                content.length > (photoPreview ? 100 : 400) ? (
                  <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
                    <Typography
                      variant="body2"
                      component="div"
                      sx={{
                        color: "#666",
                        fontSize: "14px",
                        lineHeight: 1.4,
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {content.substring(0, photoPreview ? 100 : 400)}...{" "}
                      <Typography
                        component="span"
                        onClick={() => setShowFullStory(true)}
                        sx={{
                          color: "#01579B",
                          fontSize: "14px",
                          fontWeight: "500",
                          cursor: "pointer",
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                      >
                        more
                      </Typography>
                    </Typography>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      maxHeight: photoPreview ? "120px" : "350px",
                      overflowY: "auto",
                      overflowX: "hidden",
                      flexGrow: 1,
                      mb: 3,
                      pr: 1,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#666",
                        fontSize: "14px",
                        lineHeight: 1.4,
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {content}
                    </Typography>
                  </Box>
                )}
              </CardContent>

              {/* Divider */}
              <Box
                sx={{
                  borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                  backgroundColor: "#E1F5FE",
                }}
              />

              {/* Action Buttons */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: 2,
                  py: 1,
                  backgroundColor: "#E1F5FE",
                }}
              >
                {/* Left side - Like, Comment, Share icons */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <IconButton
                    size="small"
                    sx={{
                      color: "#9e9e9e",
                      p: 0,
                      pointerEvents: "none",
                    }}
                  >
                    <FavoriteBorderOutlinedIcon fontSize="small" />
                  </IconButton>

                  <IconButton
                    size="small"
                    sx={{
                      color: "#9e9e9e",
                      p: 0,
                      pointerEvents: "none",
                    }}
                  >
                    <ModeCommentOutlinedIcon fontSize="small" />
                  </IconButton>

                  <IconButton
                    size="small"
                    sx={{
                      color: "#9e9e9e",
                      p: 0,
                      pointerEvents: "none",
                    }}
                  >
                    <ShareOutlinedIcon fontSize="small" />
                  </IconButton>

                  <IconButton
                    size="small"
                    sx={{
                      color: "#9e9e9e",
                      p: 0,
                      pointerEvents: "none",
                    }}
                  >
                    <CollectionsBookmarkIcon fontSize="small" />
                  </IconButton>
                </Box>

                {/* Right side - Story icon */}
                <IconButton
                  sx={{
                    backgroundColor: "#01579B",
                    color: "white",
                    borderRadius: "6px",
                    p: "3px",
                    pointerEvents: "none",
                    "&:hover": {
                      backgroundColor: "#01579B",
                    },
                  }}
                >
                  <AutoStoriesOutlinedIcon fontSize="small" />
                </IconButton>
              </Box>
            </Card>

            {/* OK Button */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Button
                variant="contained"
                onClick={handleClosePreview}
                sx={{
                  backgroundColor: "#EF5658",
                  color: "white",
                  borderRadius: "4px",
                  px: 5,
                  py: 1.5,
                  fontSize: "14px",
                  fontWeight: "500",
                  height: "32px",
                  textTransform: "uppercase",
                  "&:hover": {
                    backgroundColor: "#D33338",
                  },
                }}
              >
                OK
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
        <FloatingMenu left={floatMenuLeftMargin} />
      </Box>
    
  );
}
